import React, {useState, useEffect} from 'react';
import '../styling/containerStyles.css'
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Checkbox from '../components/checkbox'
import TextBox from '../components/textbox'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Label from '../components/label'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ButtonComp from '../components/button'
import CircularProgress from '@material-ui/core/CircularProgress'
import DialogBox from '../components/dialog';
import Confetti from 'react-confetti'
// for future use paytm changes in entitre file
// import paytmLogo from '../assets/images/paytmLogo.png'
import bankLogo from '../assets/images/bankLogo.png'
import fccPointsLogo from '../assets/images/fccPointsLogo.png';


interface TransactionDetailsProps{
    amount:string;
    redeemPoints: boolean;
    conversions: Array<any>;
    handleToProceed:Function;
    userType: string;
    bonusPoint?: Array<any>;
    handleValidateCoupon:Function;
    promoAmount: Array<any>;
    promoCodeMessage:string;
    setPromoCodeMessage:any;
    setPromoAmount:any;
    setPromoCode:any;
    promoLoader:any;
    setPromoLoader:any;
    promoApplied:any;
    setPromoApplied: any;
    transactionCount: any;
    cmdiPhoneNumber: any;
    cmdiName: any;
}

export const TransactionDetails: React.FC<TransactionDetailsProps> = (props: TransactionDetailsProps) =>{

    const{
        handleToProceed, amount, redeemPoints, conversions, userType, bonusPoint, handleValidateCoupon, 
        promoAmount, promoCodeMessage, setPromoCodeMessage, setPromoAmount, setPromoCode, promoLoader, 
        setPromoLoader, promoApplied, setPromoApplied, transactionCount, cmdiPhoneNumber, cmdiName
    } = props;

    const bonusAmt = bonusPoint && bonusPoint.map(b=>b.amount)
    const bonusType = bonusPoint && bonusPoint.map(b=>b.rec_type)

    const [value, setValue] = useState('')
    const [amt, setAmt] = useState('')
    const [bonusAmtVal, setBonusAmtVal] = useState('')
    const [checkboxValue, setCheckboxValue] = useState(false)
    const [couponCode, setCouponCode] = useState('')
    const [promoAmtVal, setPromoAmtVal] = useState('')
    const [open, setOpen] = useState(false)
    const [openTransactionCount, setOpenTransactionCount] = useState(false)
    // const user = userType === 'FCC'? 'FCC' : 'CWC';
    const user = userType;
    const redeemableAmt = parseFloat(amount)

    const wallet = String((redeemableAmt*parseFloat(conversions[0])).toFixed(2))
    const bank =   String((redeemableAmt*parseFloat(conversions[1])).toFixed(2))
    const points = String((redeemableAmt*parseFloat(conversions[2])).toFixed(2))
    const p_to_r = String((parseFloat(points)*parseFloat(conversions[3])).toFixed(2)) // points to reps conversion logic changes

    // ------------

    const walletBonusAmt = bonusAmt && bonusAmt[0] ?
    bonusType && bonusType[0] === "conversion" ? 
    String((redeemableAmt*parseFloat(conversions[0])*parseFloat(bonusAmt && bonusAmt[0])).toFixed(2)) : String((redeemableAmt*parseFloat(conversions[0])+parseFloat(bonusAmt && bonusAmt[0])).toFixed(2))
    : parseFloat(promoAmount && promoAmount[0])>0 ?
    String((redeemableAmt*parseFloat(conversions[0])+parseFloat(promoAmount && promoAmount[0])).toFixed(2)) :
    String((redeemableAmt*parseFloat(conversions[0])).toFixed(2))

    const bankBonusAmt = bonusAmt && bonusAmt[1] ?
    bonusType && bonusType[1] === "conversion" ? 
    String((redeemableAmt*parseFloat(conversions[1])*parseFloat(bonusAmt && bonusAmt[1])).toFixed(2)) : String((redeemableAmt*parseFloat(conversions[1])+parseFloat(bonusAmt && bonusAmt[1])).toFixed(2))
    : parseFloat(promoAmount && promoAmount[1])>0 ?
    String((redeemableAmt*parseFloat(conversions[1])+parseFloat(promoAmount && promoAmount[1])).toFixed(2)) :
    String((redeemableAmt*parseFloat(conversions[1])).toFixed(2))

    const pointsBonusAmt = bonusAmt && bonusAmt[2] ?
    bonusType && bonusType[2] === "conversion" ? 
    String((redeemableAmt*parseFloat(conversions[2])*parseFloat(bonusAmt && bonusAmt[2])).toFixed(2)) : String((redeemableAmt*parseFloat(conversions[2])+parseFloat(bonusAmt && bonusAmt[2])).toFixed(2))
    : parseFloat(promoAmount && promoAmount[2])>0 ?
    String((redeemableAmt*parseFloat(conversions[2])+parseFloat(promoAmount && promoAmount[2])).toFixed(2)) :
    String((redeemableAmt*parseFloat(conversions[2])).toFixed(2))

    const p_to_rBonusAmt = bonusAmt && bonusAmt[3] ?
    bonusType && bonusType[3] === "conversion" ? 
    String((parseFloat(points)*parseFloat(conversions[3])*parseFloat(bonusAmt && bonusAmt[3])).toFixed(2)) : String((parseFloat(points)*parseFloat(conversions[3])+parseFloat(bonusAmt && bonusAmt[3])).toFixed(2))
    : parseFloat(promoAmount && promoAmount[3])>0 ?
    String((parseFloat(points)*parseFloat(conversions[3])+parseFloat(promoAmount && promoAmount[3])).toFixed(2)) :
    String((parseFloat(points)*parseFloat(conversions[3])).toFixed(2)) // points to reps conversion logic changes

    // -------------
    

    const walletBonusAmtCalc = bonusAmt && bonusAmt[0] ?
    bonusType && bonusType[0] === "conversion" ? 
    parseFloat(promoAmount && promoAmount[0])>0 ?
    String((redeemableAmt*parseFloat(conversions[0])*parseFloat(bonusAmt && bonusAmt[0])+parseFloat(promoAmount && promoAmount[0])).toFixed(2)) : 
    String((redeemableAmt*parseFloat(conversions[0])*parseFloat(bonusAmt && bonusAmt[0])).toFixed(2)) 
    :
    parseFloat(promoAmount && promoAmount[0])>0 ?
    String((redeemableAmt*parseFloat(conversions[0])+parseFloat(bonusAmt && bonusAmt[0])+parseFloat(promoAmount && promoAmount[0])).toFixed(2)) :
    String((redeemableAmt*parseFloat(conversions[0])+parseFloat(bonusAmt && bonusAmt[0])).toFixed(2))
    : 
    parseFloat(promoAmount && promoAmount[0])>0 ?
    String((redeemableAmt*parseFloat(conversions[0])+parseFloat(promoAmount && promoAmount[0])).toFixed(2)) :
    String((redeemableAmt*parseFloat(conversions[0])).toFixed(2))

    const bankBonusAmtCalc = bonusAmt && bonusAmt[1] ?
    bonusType && bonusType[1] === "conversion" ? 
    parseFloat(promoAmount && promoAmount[1])>0 ?
    String((redeemableAmt*parseFloat(conversions[1])*parseFloat(bonusAmt && bonusAmt[1])+parseFloat(promoAmount && promoAmount[1])).toFixed(2)) : 
    String((redeemableAmt*parseFloat(conversions[1])*parseFloat(bonusAmt && bonusAmt[1])).toFixed(2))
    :
    parseFloat(promoAmount && promoAmount[1])>0 ?
    String((redeemableAmt*parseFloat(conversions[1])+parseFloat(bonusAmt && bonusAmt[1])+parseFloat(promoAmount && promoAmount[1])).toFixed(2)) : 
    String((redeemableAmt*parseFloat(conversions[1])+parseFloat(bonusAmt && bonusAmt[1])).toFixed(2))
    :
    parseFloat(promoAmount && promoAmount[1])>0 ?
    String((redeemableAmt*parseFloat(conversions[1])+parseFloat(promoAmount && promoAmount[1])).toFixed(2)) :
    String((redeemableAmt*parseFloat(conversions[1])).toFixed(2))

    const pointsBonusAmtCalc = bonusAmt && bonusAmt[2] ?
    bonusType && bonusType[2] === "conversion" ? 
    parseFloat(promoAmount && promoAmount[2])>0 ?
    String((redeemableAmt*parseFloat(conversions[2])*parseFloat(bonusAmt && bonusAmt[2])+parseFloat(promoAmount && promoAmount[2])).toFixed(2)) : 
    String((redeemableAmt*parseFloat(conversions[2])*parseFloat(bonusAmt && bonusAmt[2])).toFixed(2))
    :
    parseFloat(promoAmount && promoAmount[2])>0 ?
    String((redeemableAmt*parseFloat(conversions[2])+parseFloat(bonusAmt && bonusAmt[2])+parseFloat(promoAmount && promoAmount[2])).toFixed(2)) :
    String((redeemableAmt*parseFloat(conversions[2])+parseFloat(bonusAmt && bonusAmt[2])).toFixed(2))
    : 
    parseFloat(promoAmount && promoAmount[2])>0 ?
    String((redeemableAmt*parseFloat(conversions[2])+parseFloat(promoAmount && promoAmount[2])).toFixed(2)) :
    String((redeemableAmt*parseFloat(conversions[2])).toFixed(2))

    const p_to_rBonusAmtCalc = bonusAmt && bonusAmt[3] ?
    bonusType && bonusType[3] === "conversion" ? 
    parseFloat(promoAmount && promoAmount[3])>0 ?
    String((parseFloat(points)*parseFloat(conversions[3])*parseFloat(bonusAmt && bonusAmt[3])+parseFloat(promoAmount && promoAmount[3])).toFixed(2)) : 
    String((parseFloat(points)*parseFloat(conversions[3])*parseFloat(bonusAmt && bonusAmt[3])).toFixed(2))
    :
    parseFloat(promoAmount && promoAmount[3])>0 ?
    String((parseFloat(points)*parseFloat(conversions[3])+parseFloat(bonusAmt && bonusAmt[3])+parseFloat(promoAmount && promoAmount[3])).toFixed(2)) :
    String((parseFloat(points)*parseFloat(conversions[3])+parseFloat(bonusAmt && bonusAmt[3])).toFixed(2))
    : 
    parseFloat(promoAmount && promoAmount[3])>0 ?
    String((parseFloat(points)*parseFloat(conversions[3])+parseFloat(promoAmount && promoAmount[3])).toFixed(2)) :
    String((parseFloat(points)*parseFloat(conversions[3])).toFixed(2))

    const bonusAmtWallet =  bonusAmt && bonusAmt[0] && String(Math.abs((walletBonusAmt as any) - (wallet as any)).toFixed(2))
    const bonusAmtBank =  bonusAmt && bonusAmt[1] && String(Math.abs((bankBonusAmt as any) - (bank as any)).toFixed(2))
    const bonusAmtPoints = bonusAmt && bonusAmt[2] && String(Math.abs((pointsBonusAmt as any) - (points as any)).toFixed(2))
    const bonusAmtP_to_r = bonusAmt && bonusAmt[3] && String(Math.abs((p_to_rBonusAmt as any) - (p_to_r as any)).toFixed(2))

    const promoAmountWallet = parseFloat(promoAmount && promoAmount[0]) >0 ? String((parseFloat(promoAmount && promoAmount[0])).toFixed(2)) : "";
    const promoAmountBank = parseFloat(promoAmount && promoAmount[1]) >0 ? String((parseFloat(promoAmount && promoAmount[1])).toFixed(2)) : "";
    const promoAmountPoints = parseFloat(promoAmount && promoAmount[2]) >0 ? String((parseFloat(promoAmount && promoAmount[2])).toFixed(2)) : "";
    const promoAmountP_to_r = parseFloat(promoAmount && promoAmount[3]) >0 ? String((parseFloat(promoAmount && promoAmount[3])).toFixed(2)) : "";

    useEffect(() => {
        if (value === 'paytm') {
            setAmt(walletBonusAmtCalc)
            setBonusAmtVal(bonusAmtWallet)
            setPromoAmtVal(promoAmountWallet)
        }
        else if (value === 'bankAccount') {
            setAmt(bankBonusAmtCalc)
            setBonusAmtVal(bonusAmtBank)
            setPromoAmtVal(promoAmountBank)
        }
        else if (value === 'fccPoints') {
            setAmt(pointsBonusAmtCalc)
            setBonusAmtVal(bonusAmtPoints)
            setPromoAmtVal(promoAmountPoints)
        }
    }, [promoLoader])

    useEffect(() => {
        if(transactionCount >0 && transactionCount <5) {
            setOpenTransactionCount(true)
        }
    }, [transactionCount])

    const path = window.location.pathname;
    const pathParams = path.split('/')
    const isForPtr = pathParams[1].toLowerCase() === 'ptr'
    const product = isForPtr ? pathParams[2].toLowerCase() : pathParams[1].toLowerCase()


    const handleClick = (option: any) => {
        if(option === 'GoBack'){
            handleToProceed(option)
        }
        if(value !== ''){
            handleToProceed(value, amt, "", bonusAmtVal, promoAmtVal)
        }
        
    }
    
    const handleRadioChange = (event: any) => {
        let val = event.target.value;
        setValue(val)
        
        if(val === 'paytm'){            
            setAmt(walletBonusAmtCalc)
            setBonusAmtVal(bonusAmtWallet)
            setPromoAmtVal(promoAmountWallet)
        }
        else if( val === 'bankAccount'){
            setAmt(bankBonusAmtCalc)
            setBonusAmtVal(bonusAmtBank)
            setPromoAmtVal(promoAmountBank)
        }
        else if(val === 'fccPoints'){
            setAmt(pointsBonusAmtCalc)
            setBonusAmtVal(bonusAmtPoints)
            setPromoAmtVal(promoAmountPoints)
        }
    };

    const handleCheckboxChange = (name:string, arg: any) => {
        if (arg === false) {
            setCouponCode("")
            setPromoCode("");
            setPromoCodeMessage("")
            setPromoAmount("")
            setPromoLoader("")
            setPromoApplied(false)
        }
        setCheckboxValue(arg)
    };

    const handleToUpdateContent = (name: string, arg: string) => {
        if (name === 'promoCode') {
            setCouponCode(arg)
        }
    }

    const handleDialogOpen = () => {
        setOpen(true)
    }

    const handleDialogClose = () => {
        setOpen(false)
    }

    const handleValidateCouponClick = () => {
        if (couponCode !== '') {
            handleDialogClose();
            setPromoCodeMessage("")
            handleValidateCoupon(couponCode)
            handleDialogOpen();
        }
    }

    const handleRemoveCouponClick = () => {
        setCouponCode("")
        setPromoCode("");
        setPromoCodeMessage("")
        setPromoAmount("")
        setPromoLoader("")
        setPromoApplied(false)
    }

    const handleDialogCloseTransactionCount = () => {
        setOpenTransactionCount(false)
    }
    
        return (
            <div className='transactionDetails'>
                <div className='buttonAndLabel'>
                    <Button  className='goBack' onClick={() => {handleToProceed('GoBack')}} ><ArrowBackIosIcon /></Button>
                    <Label content='Transaction Details' />
                </div>
                <br></br>
                <div className='sideText'>Choose your payment method</div>
                {promoLoader ? 
                    <CircularProgress /> :
                <>
                {!redeemPoints && 
                <div>
                    <RadioGroup aria-label="quiz" name="quiz" id='payment' value={value} onChange={handleRadioChange}> <br></br> 
                        {/* <FormControlLabel className="transaction-list" value="paytm" control={<Radio className='radio-button' />} label={
                            <section className='menuItem'>
                                <img className='payLogo' src = {paytmLogo} alt='paytm' ></img>
                                <div className='payOption'>
                                    {parseInt(bonusAmtWallet) >0 ?
                                    <>
                                    <div className='payName'>Paytm  ({"₹ " + walletBonusAmtCalc})</div>
                                    <div className='payName bonus'>Regular  ({"₹ " + wallet}) + Bonus  ({"₹ " + bonusAmtWallet}) {parseFloat(promoAmountWallet)>0 ? ` + Promo Code (₹ ${promoAmountWallet})` : null }
                                    </div>
                                    </>
                                    :
                                    <>
                                    <div className='payName'>Paytm  ({"₹ " + walletBonusAmtCalc})</div>
                                    {parseFloat(promoAmountWallet)>0 ?
                                    <div className='payName bonus'>Regular  ({"₹ " + wallet}) + Promo Code  ({"₹ " + (promoAmountWallet)})
                                    </div> : null}
                                    </>
                                    }
                                    <div className='paySubName'>Use paytm wallet for Transaction</div>
                                </div>
                            </section>
                        }
                        /> <br></br>  */}
                        <FormControlLabel className="transaction-list" value="bankAccount" control={<Radio className='radio-button' />} label={
                            <section className='menuItem'>
                                <img className='payLogo' src = {bankLogo} alt='bank' ></img>
                                <div className='payOption'>
                                    {parseInt(bonusAmtBank) >0 ?
                                    <>
                                    <div className='payName'>Bank Account  ({"₹ " + bankBonusAmtCalc})</div>
                                    <div className='payName bonus'>Regular  ({"₹ " + bank}) + Bonus  ({"₹ " + bonusAmtBank})
                                    {parseFloat(promoAmountBank)>0 ? ` + Promo Code (₹ ${promoAmountBank})` : null }
                                    </div>
                                    </>
                                    :
                                    <>
                                    <div className='payName'>Bank Account  ({"₹ " + bankBonusAmtCalc})</div>
                                    {parseFloat(promoAmountBank)>0 ?
                                    <div className='payName bonus'>Regular  ({"₹ " + bank}) + Promo Code  ({"₹ " + (promoAmountBank)})
                                    </div> : null}
                                    </>
                                    }
                                    <div className='paySubName'>Use bank details for Transaction</div>
                                </div>
                        </section>
                        } /> <br></br>
                        </RadioGroup>
                </div>
                }
                {redeemPoints && 
                <div>
                    
                    <RadioGroup aria-label="quiz" name="quiz" id='payment' value={value} onChange={handleRadioChange}> <br></br> 
                        {/* <FormControlLabel className="transaction-list" value="paytm" control={<Radio className='radio-button' />} label={
                            <section className='menuItem'>
                                <img className='payLogo' src = {paytmLogo} alt='paytm' ></img>
                                <div className='payOption'>
                                    {parseInt(bonusAmtWallet) >0 ?
                                    <>
                                    <div className='payName'>Paytm  ({"₹ " + walletBonusAmtCalc})</div>
                                    <div className='payName bonus'>Regular  ({"₹ " + wallet}) + Bonus  ({"₹ " + bonusAmtWallet})
                                    {parseFloat(promoAmountWallet)>0 ? ` + Promo Code (₹ ${promoAmountWallet})` : null }
                                    </div>
                                    </>
                                    :
                                    <>
                                    <div className='payName'>Paytm ({"₹ " + walletBonusAmtCalc})</div>
                                    {parseFloat(promoAmountWallet)>0 ?
                                    <div className='payName bonus'>Regular  ({"₹ " + wallet}) + Promo Code  ({"₹ " + (promoAmountWallet)})
                                    </div> : null}
                                    </>
                                    }
                                    <div className='paySubName'>Use paytm wallet for Transaction</div>
                                </div>
                            </section>
                        }
                        /> <br></br>  */}
                        <FormControlLabel className="transaction-list" value="bankAccount" control={<Radio className='radio-button' />} label={
                            <section className='menuItem'>
                                <img className='payLogo' src = {bankLogo} alt='bank' ></img>
                                <div className='payOption'>
                                    {parseInt(bonusAmtBank) >0 ?
                                    <>
                                    <div className='payName'>Bank Account  ({"₹ " + bankBonusAmtCalc})</div>
                                    <div className='payName bonus'>Regular  ({"₹ " + bank}) + Bonus  ({"₹ " + bonusAmtBank})
                                    {parseFloat(promoAmountBank)>0 ? ` + Promo Code (₹ ${promoAmountBank})` : null }
                                    </div>
                                    </>
                                    :
                                    <>
                                    <div className='payName'>Bank Account  ({"₹ " + bankBonusAmtCalc})</div>
                                    {parseFloat(promoAmountBank)>0 ?
                                    <div className='payName bonus'>Regular  ({"₹ " + bank}) + Promo Code  ({"₹ " + (promoAmountBank)})
                                    </div> : null}
                                    </>
                                    }
                                    <div className='paySubName'>Use bank details for Transaction</div>
                                </div>
                        </section>
                        } /> <br></br>
                        {!localStorage.getItem('IS_DEALER_LOGIN') && (
                            <>
                                {product !== "upscaleceiling" && product !== "upscaleinteco" &&
                                    <>
                                        <FormControlLabel className="transaction-list" value="fccPoints" control={<Radio className='radio-button' />} label={
                                            <section className='menuItem'>
                                                <img className='payLogo' src = {fccPointsLogo} alt='FCC points' ></img>
                                                <div className='payOption'>
                                                    {parseInt(bonusAmtPoints) >0 ?
                                                    <>
                                                    <div className='payName'>{user} Points ({pointsBonusAmtCalc + " Points"}/ {"₹ " + p_to_rBonusAmtCalc})</div>
                                                    <div className='payName bonus'>Regular ({points + " Points"}/ {"₹ " + p_to_r}) + Bonus ({bonusAmtPoints + " Points"}/ {"₹ " + bonusAmtP_to_r}) {parseFloat(promoAmountPoints)>0 ? ` + Promo Code ${promoAmountPoints + " Points"}/ (₹ ${promoAmountP_to_r})` : null }
                                                    </div>
                                                    </>
                                                    :
                                                    <>
                                                    <div className='payName'>{user} Points ({pointsBonusAmtCalc + " Points"}/ {"₹ " + p_to_rBonusAmtCalc})</div>
                                                    {parseFloat(promoAmountPoints)>0 ?
                                                    <div className='payName bonus'>Regular ({points + " Points"}/ {"₹ " + p_to_r}) + Promo Code  ({promoAmountPoints + " Points"}/ {"₹ " + (promoAmountP_to_r)})</div>
                                                    : null}
                                                    </>
                                                    }
                                                    <div className='paySubName'>A special loyalty program for contractors by Pidilite</div>
                                                </div>
                                            </section>
                                        } /> <br></br>
                                    </> 
                                }
                            </>
                        )}
                    </RadioGroup>
                </div>
                }
                </> }
                <FormControlLabel
                    className="paySubName" value="paytm"
                    control={
                        <Checkbox
                            handleToUpdate={handleCheckboxChange}
                            value={checkboxValue}
                            name="extra_coupon"
                        />
                    }
                    label={"Do you have a promo code?"}
                />
                {checkboxValue === true ?
                    <div className='promo_code_div'>
                        <TextBox className='textBox custom_input'
                            label={'Promo code'}
                            state={'promoCode'}
                            placeholder={''}
                            value={couponCode}
                            disabled={promoApplied ? true : false}
                            handleToUpdate={handleToUpdateContent}
                        />
                        {promoApplied ?
                            <ButtonComp label={'remove'}
                                name={'REMOVE'}
                                visible={true}
                                handleToUpdate={handleRemoveCouponClick}
                            />
                            :
                            <ButtonComp label={'apply'}
                                name={'APPLY'}
                                visible={true}
                                disabled={!couponCode || promoLoader}
                                handleToUpdate={handleValidateCouponClick} />
                        }
                    </div>
                    : null}
                {checkboxValue === true && !promoApplied ?
                    <div className={'message'}>{promoCodeMessage}</div>
                    : null
                }
                {transactionCount >0 && transactionCount <5 &&
                <DialogBox handleDialogClose={handleDialogCloseTransactionCount} open={openTransactionCount}
                message={`You can scan only 5 coupons To enjoy further benefits in CWC Dr. Fixit, Call your ${cmdiName} Now - <a href="tel:${cmdiPhoneNumber}">${cmdiPhoneNumber}</a>`} 
                imgDisp={false} />
                }
                <ButtonComp label={'Proceed'}
                    name={'PROCEED'}
                    visible={true}
                    handleToUpdate={handleClick} />
                {open && promoApplied ?
                    <Confetti
                        numberOfPieces={60}
                    /> : null}
                {promoApplied ?
                    <DialogBox handleDialogClose={handleDialogClose} open={open}
                        message={promoCodeMessage} /> :
                    null}
            </div>                    
        )
    }


export default TransactionDetails